export default function PageHeader({ overline, title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6 pb-5 border-b border-border animate-fade-up">
      <div>
        <span className="block h-1 w-10 rounded-full bg-brand-red-grad mb-3" />
        {overline && (
          <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-primary mb-1.5">{overline}</div>
        )}
        <h1 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1.5 max-w-2xl">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
